class SocketFactory {
    keys;
    sendQueue;
    ws;
    HOST;
    constructor(){
        this.keys = [];
        this.listeners = {};
        this.sendQueue = [];
        this.HOST = (window.location.protocol + '//' + window.location.hostname + '/socket/market-data').replace(/^http/, 'ws');
    }

    connect(message, params, callBack){
        let ws = new WebSocket(this.HOST);
        this.ws = ws;
        //console.log('connect to HOST : ', this.HOST)
        ws.onopen = function () {
            console.log("[open] Connection established");
            console.log("Sending to server");
            ws.send(JSON.stringify({ message: message, params: params }))
        }
        ws.onerror = function (err) {
            console.log("Error", err.message);
        }
        ws.onmessage = function (e) {
            try {
                const parsed = JSON.parse(e.data);
                callBack(parsed)
            } catch (err) {
                console.log("catch error", err.message);
            }
        }
        ws.onclose = function close(event) {
            if (event.wasClean) {
                console.log("Connection closed cleanly, code=", event.code, "reason=", event.reason);
            } else { console.log('Connection died') }
        }
    }
    close(){
        this.ws.close();
    }
}

export default SocketFactory;